import React from 'react';
import { LoadingSpinner } from '../../../components/LoadingSpinner';

/** Phasen der PDF-Erzeugung in der Vorschau; die Reihenfolge ist die Anzeige-Reihenfolge. */
export type PdfPreviewPhase = 'measure' | 'layout' | 'attachments' | 'zugferd';

const PHASE_LABEL: Record<PdfPreviewPhase, string> = {
  measure: 'Seiten werden vermessen…',
  layout: 'Seiten werden gesetzt…',
  attachments: 'Anhänge werden angefügt…',
  zugferd: 'E-Rechnung wird eingebettet…',
};

/**
 * Platzhalter in der PDF-Vorschau, solange das Dokument gebaut wird. Liegt im selben Raster wie
 * der PdfDocumentViewer (p-3, Seite in voller Breite, A4-Verhältnis), damit die erste echte Seite
 * den Platzhalter deckungsgleich ersetzt und nichts springt. Der Spinner läuft per CSS weiter,
 * auch während react-pdf den Haupt-Thread blockiert; der Text wechselt zwischen den Durchläufen.
 */
export function PdfPreviewLoadingPanel({ phase }: { phase: PdfPreviewPhase | null }) {
  return (
    <div
      className="relative flex min-h-0 w-full flex-1 flex-col overflow-hidden bg-neutral-800 p-3"
      role="status"
      aria-live="polite"
    >
      <div className="relative mx-auto w-full shrink-0 overflow-hidden bg-white shadow-sm ring-1 ring-black/5 aspect-[210/297]" aria-hidden>
        <div className="space-y-3 p-[7%]">
          <div className="h-3 w-1/3 rounded bg-slate-200" />
          <div className="h-2.5 w-1/4 rounded bg-slate-100" />
          <div className="pt-8" />
          <div className="h-2.5 w-2/5 rounded bg-slate-100" />
          <div className="h-2.5 w-1/3 rounded bg-slate-100" />
          <div className="pt-6" />
          <div className="h-4 w-3/4 rounded bg-slate-200" />
          <div className="pt-4" />
          {Array.from({ length: 7 }, (_, i) => (
            <div key={i} className="flex gap-3">
              <div className="h-2.5 w-8 rounded bg-slate-100" />
              <div className="h-2.5 flex-1 rounded bg-slate-100" />
              <div className="h-2.5 w-14 rounded bg-slate-100" />
            </div>
          ))}
        </div>
      </div>
      <div className="pointer-events-none absolute inset-0 flex items-center justify-center p-3">
        <div className="flex flex-col items-center gap-2 rounded-lg bg-neutral-900/80 px-5 py-4 text-center shadow-lg backdrop-blur-sm">
          <LoadingSpinner className="text-white" />
          <p className="text-sm font-medium text-white">{phase ? PHASE_LABEL[phase] : 'PDF wird vorbereitet…'}</p>
          <p className="text-xs text-neutral-300">Bei langen Dokumenten kann das einige Sekunden dauern.</p>
        </div>
      </div>
    </div>
  );
}
